module.exports = __webpack_public_path__ + "static/media/1013001BE.02c756f6.jpg";